module.exports = __webpack_public_path__ + "static/logan-034d9f9dae0c937b9d56f467d7188cf9.png";